import { Config, State } from "../services.js";
import axios from "axios";
import {NetworkHelper, CryptoHelper} from "clariant-helpers-vue3";

var DataLayer = {
    newInstallation () {
        return {
            name: "",
            location: "",
            application: "",
            segment: "",
            product: "",
            otherProduct: "",
            volume: "",
            fillDate: "",
            metals: "",
            otherMetals: "",
            invalid: false
        }
    },
    getJson(url) {
        return new Promise((resolve, reject) => {
            NetworkHelper.get(url).then(({data}) => {
                if (typeof(data) === "string") {
                    resolve(JSON.parse(data));
                } else {
                    resolve(data);
                }
            }).catch (err => reject(err));
        });
    },
    loadLists() {
        let url = `${Config.wsUrl}/lists?lang=${State.language}`;
        return this.getJson(url);
    },
    getDistributors() {
        let url = `${Config.wsUrl}/sampledistributors?lang=${State.language}`;
        return this.getJson(url);
    },
    checkAppVersion() {
        let url = `${Config.wsUrl}/checkVersion`;
        return this.getJson(url);
    },
    submitRequest() {
        let url = `${Config.wsUrl}/sample`;
        State.signature = this.computeSignature();
        return axios.post(url, State);
    },
    computeSignature() {
        return CryptoHelper.Sha256(`${State.firstName}||${State.lastName}||${State.email}||${State.installations.length}||${State.distributor}`);
    },
    checkVoucher(voucherNumber){
        let url = `${Config.wsUrl}/checkVoucher?voucher=${voucherNumber}`;
        return this.getJson(url);
    }
};

export default DataLayer;